// Миксин, добавляющий поле errors и методы для работы с ним
const data = function () {
    return { errors: [] };
};

const methods = {
    clearErrors() {
        this.errors = [];
    },

    setErrors(errors) {
        this.errors = !Array.isArray(errors) ? [errors] : errors;
    },

    addError(error) {
        if (error === "") {
            return;
        }
        this.errors.push(error);
    },

    hasErrors() {
        return this.errors.length;
    },
};

const computed = {
    error() {
        return this.errors.join("<br/>");
    },
};

export default {
    data,
    methods,
    computed,
};
